import { useMatch, useSearchParams } from 'react-router-dom';

export const MEMBERSHIP_SUCCESS_PARAM = 'membershipSuccess';

function useStatusParam() {
    const [searchParams] = useSearchParams();
    const isAccountRoute = !!useMatch('/account/*');
    const isShopRoute = !!useMatch('/shop/*');

    /*
        NOTE: Mango redirects to Boysenberry after sign-up with an extra ? in the url
        For example: /shop??status=membershipSuccess, and we're accommodating for that here with .get('?status')
    */
    const isMembershipSuccess =
        (searchParams.get('status') || searchParams.get('?status')) === MEMBERSHIP_SUCCESS_PARAM;

    return {
        isMembershipSuccess,
        isShopMembershipSuccess: isMembershipSuccess && isShopRoute,
        isAccountMembershipSuccess: isMembershipSuccess && isAccountRoute,
    };
}

export default useStatusParam;
